function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import deepmerge from 'deepmerge';
import { CoreVideoInternal } from '../../core-video-internal';
import { sdkLogger } from '../../logger';
import { InternalConfigProvider } from '../../config/internal-config-provider';
import { DeferredEventQueue } from './deferred-event-queue';
var DEFER_TIME_MILLISECONDS = 12000;
export var ReportingManager = /*#__PURE__*/ function() {
    "use strict";
    function ReportingManager(session, reportingFactories, sessionItem) {
        _class_call_check(this, ReportingManager);
        _define_property(this, "session", void 0);
        _define_property(this, "reportingFactories", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "reportingAddons", void 0);
        _define_property(this, "eventQueue", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "_initialised", void 0);
        this.session = session;
        this.reportingFactories = reportingFactories;
        this.sessionItem = sessionItem;
        this.reportingAddons = new Array();
        this.eventQueue = null;
        this.logger = sdkLogger.withContext('ReportingManager');
        this._initialised = false;
    }
    _create_class(ReportingManager, [
        {
            key: "initialise",
            value: function initialise() {
                this.eventQueue = new DeferredEventQueue(CoreVideoInternal.capabilities.hasLowerEndSpecs() ? DEFER_TIME_MILLISECONDS : 0);
                // TODO: Create a better way to support addonsConfigOverride across all the addons
                // OR just remove support for the api.
                // https://github.com/sky-uk/core-video-team/issues/7837
                var config = InternalConfigProvider.getForPlaybackType(CoreVideoInternal.config, this.sessionItem.type);
                var addonsConfigWithOverrides = this.applyAddonsConfigOverrides(config.addons, this.sessionItem.addonsConfigOverride);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (this.reportingFactories || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var raf = _step.value;
                        var reportingSessionConfig = addonsConfigWithOverrides.reporting || config.addons.reporting;
                        var reportingAddonSessionData = {
                            common: addonsConfigWithOverrides.common || config.addons.common,
                            reportingSessionConfig: reportingSessionConfig,
                            session: this.session,
                            sessionItem: this.sessionItem,
                            eventQueue: this.eventQueue
                        };
                        try {
                            var addon = raf(reportingAddonSessionData);
                            if (addon) {
                                this.reportingAddons.push(addon);
                            }
                        } catch (e) {
                            var msg = "Error while loading reporting addon: ".concat(e);
                            sdkLogger.error(msg, e);
                            this.session.notifyWarning('REPORTING_MANAGER.LOAD', msg);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._initialised = true;
            }
        },
        {
            key: "initialised",
            get: function get() {
                return this._initialised;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                var _this_eventQueue;
                (_this_eventQueue = this.eventQueue) === null || _this_eventQueue === void 0 ? void 0 : _this_eventQueue.executePending();
                this.reportingAddons.forEach(function(addon) {
                    try {
                        addon.destroy();
                        _this.logger.verbose("Addon ".concat(addon.name, " destroyed"));
                    } catch (e) {
                        _this.logger.warn("Error destroying addon ".concat(addon.name), e);
                    }
                });
            }
        },
        {
            key: "getReportingAddons",
            value: function getReportingAddons() {
                return this.reportingAddons;
            }
        },
        {
            key: "applyAddonsConfigOverrides",
            value: function applyAddonsConfigOverrides(addonsConfig, sessionAddonOverrides) {
                return deepmerge(_object_spread({}, addonsConfig), _object_spread({}, sessionAddonOverrides));
            }
        }
    ]);
    return ReportingManager;
}();

//# sourceMappingURL=reporting-manager.js.map